let lastKnownScrollPosition = 0;
let ticking = false;

const didScroll = ( scrollPos: number ) => {
  if ( window.innerWidth >= 768 && scrollPos >= 400 ) {
    document.body.classList.add( 'scrolled' );
  }
  else {
    document.body.classList.remove( 'scrolled' );
  }
}

const scrollEventHandler = ( e: Event ) => {
  lastKnownScrollPosition = window.scrollY;

  if ( ! ticking ) {
    window.requestAnimationFrame( () => {
      didScroll( lastKnownScrollPosition );
      ticking = false;
    } );
  }

  ticking = true;
}

export default function() {
  document.addEventListener( 'scroll', scrollEventHandler, false );
}
